import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class MenuService {
  private readonly model: MenuItem[] = [
    {
      id: 'menu-dashboard',
      label: 'Dashboard',
      icon: 'pi pi-home',
      routerLink: '/'
    },
    {
      id: 'gestao',
      label: 'Gestão',
      icon: 'pi pi-briefcase',
      items: [
        {
          id: 'gestao-contas',
          label: 'Clientes',
          icon: 'pi pi-users',
          routerLink: '/contas-tabs'
        },
        {
          id: 'gestao-contratado',
          label: 'Contratos',
          icon: 'pi pi-file',
          routerLink: '/gestao-contratos'
        },
        {
          id: 'gestao-consumido',
          label: 'Consumos',
          icon: 'pi pi-chart-line',
          routerLink: '/gestao-consumos'
        },
        {
          id: 'gestao-extrato',
          label: 'Extrato Consumo',
          icon: 'pi pi-list',
          routerLink: '/extrato-cliente'
        },
      ]
    },
    {
      id: 'processamento',
      label: 'Processamento',
      icon: 'pi pi-sync',
      items: [
        {
          id: 'processamento-1',
          label: 'Status Processamento',
          icon: 'pi pi-clock',
          routerLink: '/status-processamento'
        },
        {
          id: 'processamento-2',
          label: 'Processamento Manual',
          icon: 'pi pi-play',
          routerLink: '/sincronismo-processamento-manual'
        }
      ]
    },
    {
      id: 'configuracoes',
      label: 'Configurações',
      icon: 'pi pi-cog',
      items: [
        {
          id: 'config-1',
          label: 'Agendamento',
          icon: 'pi pi-calendar',
          routerLink: '/configuracoes-agendamento'
        },
        {
          id: 'config-2',
          label: 'Gerais',
          icon: 'pi pi-sliders-h',
          routerLink: '/configuracoes-gerais'
        }
      ]
    },
    {
      id: 'notificacoes',
      label: 'Notificações',
      icon: 'pi pi-bell',
      routerLink: '/notificacoes'
    },
    {
      id: 'ajuda',
      label: 'Ajuda',
      icon: 'pi pi-book',
      routerLink: '/ajuda'
    },
    {
      id: 'release-notes',
      label: 'Release Notes',
      icon: 'pi pi-history',
      routerLink: '/release-notes'
    }
  ];

  items(): MenuItem[] {
    return this.model;
  }
}
